import React from 'react';
import T from 'prop-types';
// components
import CircleProgress from '../../../components/CircleProgress/CircleProgress';
// utils
import get from 'lodash.get';
import findIndex from 'lodash.findindex';
import daysDiff from '../../../utils/daysDiff';
// styles
import styles from './ProgressIndicators.mod.css';

const prepareData = ({ impact, userStats }) => {
  const indicators = get(
    impact,
    'content_progress.question_progresses',
    []
  ).map(qp => {
    const { question, question_answer_progresses } = qp;
    const pData = question_answer_progresses.sort(
      (x, y) => x.question_answer_id - y.question_answer_id
    );
    return {
      label: question.title,
      progress: String(
        25 *
          Math.max(
            findIndex(pData, ({ value }) => !!value),
            0
          )
      ),
    };
  });

  const { start, best_attempt_start, best_attempt_stop } = userStats;

  return [
    {
      label: 'Without pornography',
      value: daysDiff(start),
      unit: 'days',
    },
    ...indicators.slice(0, 4),
    {
      label: 'Best score',
      value: best_attempt_stop
        ? daysDiff(best_attempt_start, best_attempt_stop)
        : daysDiff(start),
      unit: 'days',
    },
    ...indicators.slice(4),
  ];
};

const ProgressIndicators = ({ userColor, impact, userStats }) => {
  const progressData = prepareData({ impact, userStats });
  return (
    <div className={styles.container}>
      {progressData.map(({ label, progress, value, unit }, index) => (
        <div className={styles.indicator} key={index}>
          {progress ? (
            <CircleProgress
              progress={progress}
              className={styles.progress}
              initialAnimation
              styles={{
                path: { stroke: userColor },
              }}
            />
          ) : (
            <div className={styles.value}>
              {isNaN(value) ? 0 : value}
              {unit && <div className={styles.unit}>{unit}</div>}
            </div>
          )}
          <div className={styles.label}>{label}</div>
        </div>
      ))}
    </div>
  );
};

ProgressIndicators.propTypes = {
  userColor: T.string.isRequired,
};

export default ProgressIndicators;



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/ProgressIndicators.js